import router from '@/router';
import auth from '@/common/auth/auth';

function getRoute(binding) {
    try {
        // vue parses the expression passed
        // to the directive and exposes each
        // param as a key inside `value`, so
        // we copy the values from the binding
        // and use it as the route
        return {...binding.value};
    } catch (err) {
        return null;
    }
}

export default function RoutingDirectives() {
    return {
        /* eslint-disable func-names */
        /* eslint-disable object-shorthand */
        install: function (Vue) {
            // usable as v-push="{name: 'dashboard'}"
            Vue.directive('push', {
                bind(el, binding) {
                    const route = getRoute(binding);
                    if (route) {
                        // cache route directly on element
                        el.$$route = route;
                        if (auth.$pages[route.name].isAllowed) {
                            el.addEventListener('click', () => {
                                router.push(el.$$route);
                            });
                        }
                    } else {
                        // bad routes should only happen in development
                        throw new Error('Unable to bind push directive on element');
                    }
                },
                update(el, binding) {
                    const route = getRoute(binding);
                    if (route) {
                        el.$$route = route;
                    }
                },
            });
        },
    };
}
